import { getCdnUrl } from 'owa-config';

const SMIME_VERSION = '20.20.729.1';

/**
 * S/MIME default extension installer url
 */
export function getSmimeInternetExplorerExtensionUrl() {
    return `https:${getCdnUrl()}owasmime/${SMIME_VERSION}/owasmime.msi`;
}

/**
 * S/MIME Edge extension installer url
 */
export function getSmimeLegacyEdgeExtensionUrl() {
    return `https:${getCdnUrl()}owasmime/${SMIME_VERSION}/OwaSmimeEdgeExtension.appxbundle`;
}

/**
 * S/MIME chrome control installer url
 */
export function getSmimeChromeControlUrl() {
    return `https:${getCdnUrl()}owasmime/${SMIME_VERSION}/SmimeOutlookWebChrome.msi`;
}

/**
 * S/MIME edge chromium control installer url
 */
export function getSmimeEdgeChromiumControlUrl() {
    return `https:${getCdnUrl()}owasmime/${SMIME_VERSION}/SmimeOutlookWebChrome.msi`;
}
